import { Component, Input } from '@angular/core';
import { DetailPanelComponent } from '../../../../../core/panels/detail-panel/detail-panel.component';
import { DetailItemComponent } from '../../../../../core/panels/detail-panel/detail-item.component';
import { AddressLabelComponent } from '../../../../../core/labels/address-label.component';

@Component({
  selector: 'app-risk-unit-item-detail',
  imports: [DetailItemComponent, DetailPanelComponent, AddressLabelComponent],
  template: `<div class="tw-flex tw-gap-8">
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Comment" name="comment" />
      </app-detail-panel>
    </div>
    <div class="tw-basis-1/3">
      <app-detail-panel [dataSource]="dataSource">
        <app-detail-item label="Address">
          <ng-template let-data #value>
            <app-address-label
              [street1]="dataSource.address1"
              [city]="dataSource.city"
              [state]="dataSource.state"
              [postalCode]="dataSource.postalCode"
              [county]="dataSource.county"
              [country]="dataSource.country"
            />
          </ng-template>
        </app-detail-item>
      </app-detail-panel>
    </div>
  </div>`,
  styles: [],
})
export class RiskUnitItemDetailComponent {
  @Input() dataSource: any;
}
